import React, { useCallback } from 'react'

import { ExternalLinkProps } from 'src/constants'
import { Button, T, VStack } from 'src/govwell-ui'
import { useResetAuthState } from 'src/hooks/use-reset-auth-state'

const ProdCopyAccessDenied = () => {
  const resetAuthState = useResetAuthState()

  const handleSignOut = useCallback(async () => {
    await resetAuthState()
  }, [resetAuthState])

  return (
    <VStack className="h-screen items-center justify-center gap-4 p-8">
      <T.H2>Access Restricted</T.H2>
      <T.Body className="max-w-md text-center">
        This environment is for internal use only. Please visit{' '}
        <a
          href="https://app.govwell.com"
          className="text-blue-600 underline"
          {...ExternalLinkProps}
        >
          app.govwell.com
        </a>{' '}
        to access your account.
      </T.Body>
      <Button onClick={handleSignOut}>Sign out</Button>
    </VStack>
  )
}

export default React.memo(ProdCopyAccessDenied)
